import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Diary.cssmodule.less';
import { clickButton, updateItemIndex } from '../../actions/Modal';
import {
    pagerActionTypes,
    compStatusTypes,
    ModalTypes,
    ContentTypes,
} from '@/Constants';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';

class Diary extends BaseComponent {
    constructor(props) {
        super(props);
        this.setDiaryTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    setDiaryTheme(theme) {
        const themeStyle = this.getTheme(theme, ModalTypes.DIARY);
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    makeContentView(viewItem, index) {
        const {
            type = ContentTypes.TEXT,
            content = '',
            character = {},
        } = viewItem;
        let contentView = null;
        switch (type) {
            case ContentTypes.TEXT: {
                contentView = (
                    <div
                        key={`content${type}${index}`}
                        className={this.Style[type]}
                    >
                        <div
                            className={this.Style.htmlContent}
                            dangerouslySetInnerHTML={{
                                __html: content,
                            }}
                        />
                    </div>
                );
                break;
            }
            case ContentTypes.CHARACTER_TEXT: {
                const { image = '' } = character;
                contentView = (
                    <div
                        key={`content${type}${index}`}
                        className={this.Style[type]}
                    >
                        <img
                            src={image}
                            className={this.Style.characterImage}
                        />
                        <div
                            className={this.Style.htmlContent}
                            dangerouslySetInnerHTML={{
                                __html: content,
                            }}
                        />
                    </div>
                );
                break;
            }
            case ContentTypes.IMAGE: {
                contentView = (
                    <div
                        key={`content${type}${index}`}
                        className={this.Style[type]}
                    >
                        <img src={content} className={this.Style.image} />
                    </div>
                );
                break;
            }
            case ContentTypes.BLOCK: {
                contentView = (
                    <div
                        key={`content${type}${index}`}
                        className={this.Style[type]}
                        ref={(blockWrapper) => {
                            if (blockWrapper) {
                                const blockRenderView = new Entry.RenderView(
                                    blockWrapper,
                                    'LEFT_MOST'
                                );
                                blockRenderView.changeCode(
                                    new Entry.Code(content),
                                    true
                                );
                            }
                        }}
                    />
                );
                break;
            }
        }
        return contentView;
    }

    render() {
        const { item = {} } = this.props;
        const { className, title = '', content } = item;
        const { image = '', content: popupContent = '' } = content;

        return (
            <div className={`${this.Style.Diary} ${this.Style[className]}`}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {title}
                </Title>
                <div className={this.Style.contentView}>
                    <img src={image} />
                    <div className={this.Style.content}>{popupContent}</div>
                    <Button
                        className={this.Style.button}
                        text={this.Utils.getLang('Buttons.course_done')}
                        onClick={() => this.handleButtonClick('ok')}
                    />
                </div>
            </div>
        );
    }
}

Diary.displayName = 'Diary';
Diary.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton, updateItemIndex };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(Diary);



// WEBPACK FOOTER //
// ./components/ModalSet/Diary.js